module.exports = __webpack_public_path__ + "static/Giant_Storm-3c1c85f60a528504fbe6aee55254e5ad.jpg";